import CommonUiModel from "../common/commonUiModel";

const LookupType = new CommonUiModel({
    title: "LookupType",
    gridTitle: 'Lookups',
    formTitle: 'Lookups',
    permissions: { add: false, edit: false, delete: false },
    addUrlParamKey: 'LookupType',
    module: 'Lookup',
    showHistory: false,
    columns: [
        {
            field: 'LookupType',
            label: 'Name',
            max: 64,
            width: 150
        },
        {
            field: 'Description',
            label: 'Description',
            multiline: true
        }
    ]
});

export default LookupType;